import { createSlice } from "@reduxjs/toolkit";

// notification and error message state
const messageSlice = createSlice({
    name: 'message',
    initialState: {
        isNoti: false, // indicate whether messages are noti or not
        noti: '', // save the noti msg
        isError: false, // indicate whether messages are error or not
        error: '', // save the error msg
    },
    reducers: {
        // noti handler
        toggleNoti(state, { payload: { indicator, msg } }) {
            state.isNoti = indicator
            state.noti = msg
        },
        // error handler
        toggleError(state, { payload: { indicator, msg } }) {
            state.isError = indicator
            state.error = msg
        }
    }
})

export const {
    toggleNoti,
    toggleError
} = messageSlice.actions
export default messageSlice